import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables";
import moment from "moment";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import e from "cors";
import { saveXeroInvioce } from "Listfunction";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class xeroInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from_date: new Date(),
      to_date: new Date(),
      from_date_err: "",
      to_date_err: "",
      order_list: "",
      order_list_err: "",
      generate_by: "1",
      errormessages: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>Xero invoice saved successfully.</div>,
      level: level,
      position: position,
      autoDismiss: 3,
    });
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  async onSubmit() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var error = false;
    var from_date_err = "";
    var to_date_err = "";
    var order_list_err = "";

    if (this.state.generate_by == 1) {
      if (this.state.from_date == "" || this.state.from_date == null) {
        error = true;
        from_date_err = (
          <small className="text-danger">Please select from date</small>
        );
      } else {
        from_date_err = "";
      }

      if (this.state.to_date == "" || this.state.to_date == null) {
        error = true;
        to_date_err = (
          <small className="text-danger">Please select to date</small>
        );
      } else if (
        new Date(this.state.to_date) < new Date(this.state.from_date)
      ) {
        error = true;
        to_date_err = (
          <small className="text-danger">
            To date should be greater than or equal to from date
          </small>
        );
      } else {
        to_date_err = "";
      }
    }

    if (this.state.generate_by == 2) {
      if (this.state.order_list == "" || this.state.order_list == null) {
        error = true;
        order_list_err = (
          <small className="text-danger">Please enter order ids</small>
        );
      }
    }

    this.setState({
      from_date_err: from_date_err,
      to_date_err: to_date_err,
      order_list_err: order_list_err,
    });

    if (!error) {
      var from_date = moment(this.state.holiday_day).format("YYYY-MM-DD");
      var to_date = moment(this.state.holiday_day).format("YYYY-MM-DD");

      var order_id_list = this.state.order_list;
      order_id_list = this.state.order_list.split(",");

      if (this.state.generate_by == 1) {
        order_id_list = [];
      } else if (this.state.generate_by == 2) {
        from_date = "";
        to_date = "";
      }

      saveXeroInvioce(obj, from_date, to_date, order_id_list)
        .then((res) => {
          this.handleSuccess("bl");
          this.setState({
            from_date: new Date(),
            to_date: new Date(),
            from_date_err: "",
            to_date_err: "",
            order_list: "",
            order_list_err: "",
            generate_by: "1",
          });
        })
        .catch((err) => {
          this.handleNetworkError("bl", error);
        });
    }
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleStartDateChange = (date, name) => {
    console.log(date, name);
    if (name == "from_date") {
      this.setState({
        from_date_err: "",
        from_date: date,
      });
    }

    if (name == "to_date") {
      this.setState({
        to_date_err: "",
        to_date: date,
      });
    }
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            content={
              <form>
                {errormessages.length != 0 && (
                  <div className=" alert alert-danger">
                    {errormessages.map((data) => (
                      <React.Fragment>
                        <li>{data}</li>
                      </React.Fragment>
                    ))}
                  </div>
                )}
                <div>
                  <ControlLabel>Invoice Generate By</ControlLabel>
                  <div className="alter_xeroInv">
                    <Radio
                      style={{ display: "inline-block" }}
                      number="1"
                      option="1"
                      name="generate_by"
                      onChange={(e) => {
                        this.onChange(e);
                        this.setState({
                          order_list_err: "",
                          from_date_err: "",
                          to_date_err: "",
                        });
                      }}
                      checked={this.state.generate_by === "1"}
                      label="Date Range"
                    />
                    <Radio
                      style={{ display: "inline-block" }}
                      number="2"
                      option="2"
                      name="generate_by"
                      onChange={(e) => {
                        this.onChange(e);
                        this.setState({
                          order_list_err: "",
                          from_date_err: "",
                          to_date_err: "",
                        });
                      }}
                      checked={this.state.generate_by === "2"}
                      label="Order"
                    />
                  </div>
                </div>

                {this.state.generate_by == 1 ? (
                  <Row>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <ControlLabel>From Date</ControlLabel>
                        <Datetime
                          format="y-MM-dd h:mm:ss"
                          timeFormat={false}
                          dateFormat={true}
                          inputProps={{ placeholder: "DD/MM/YYYY" }}
                          defaultValue={this.state.from_date}
                          closeOnSelect={true}
                          name="from_date"
                          value={this.state.from_date}
                          onChange={(date) =>
                            this.handleStartDateChange(date, "from_date")
                          }
                          className={`datetime-timeselect`}
                        />
                        {this.state.from_date_err}
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup>
                        <ControlLabel>To Date</ControlLabel>
                        <Datetime
                          format="y-MM-dd h:mm:ss"
                          timeFormat={false}
                          dateFormat={true}
                          inputProps={{ placeholder: "DD/MM/YYYY" }}
                          defaultValue={this.state.to_date}
                          closeOnSelect={true}
                          name="to_date"
                          value={this.state.to_date}
                          onChange={(date) =>
                            this.handleStartDateChange(date, "to_date")
                          }
                          className={`datetime-timeselect`}
                        />
                        {this.state.to_date_err}
                      </FormGroup>
                    </Col>
                  </Row>
                ) : (
                  <div>
                    <FormGroup>
                      <ControlLabel>Order Ids</ControlLabel>
                      <FormControl
                        type="text"
                        name="order_list"
                        value={this.state.order_list}
                        onChange={(e) => {
                          this.onChange(e);
                          this.setState({
                            order_list_err: "",
                          });
                        }}
                        placeholder="Enter order ids saperated by comma e.g. 1,2"
                      />
                      {this.state.order_list_err}
                    </FormGroup>
                  </div>
                )}

                <div className="slot_action_group">
                  <Button
                    onClick={this.onSubmit.bind(this)}
                    className="btn-color"
                    fill
                  >
                    Save
                  </Button>
                </div>
              </form>
            }
          />
        </Grid>
      </div>
    );
  }
}

export default xeroInvoice;
